export const getCategoryImage = (name) => {
  switch (name) {
    case 'happiness': return '/Smiling_Face.png';
    case 'time': return '/Alarm_Clock.png';
    case 'engagement': return '/Person_In_Lotus_Position.png';
    case 'capabilities': return '/Smiling_Face_With_Sunglasses.png';
    case 'emotional': return '/Star_Struck.png';
    default: return name;
  }
}